// src/components/profile-components/EditProfileScreen.js
import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Loader2, Save, ArrowRight } from 'lucide-react';
import { getUserProfile, updateUserProfile } from '../../services/profileService';
import { goBack } from '../../utils/navigation';   // ✅ جدید

export const EditProfileScreen = () => {
  const navigate = useNavigate();
  const [form, setForm] = useState({ full_name: '', email: '', phone_number: '' });
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [message, setMessage] = useState('');

  useEffect(() => {
    const fetchProfile = async () => {
      try {
        const res = await getUserProfile();
        const data = res.data?.data || res.data;
        setForm({
          full_name: data.full_name || '',
          email: data.email || '',
          phone_number: data.phone_number || '',
        });
      } catch (err) {
        console.error('Error fetching profile:', err);
        setMessage('خطا در دریافت اطلاعات کاربری.');
      } finally {
        setLoading(false);
      }
    };
    fetchProfile();
  }, []);

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSaving(true);
    setMessage('');
    try {
      await updateUserProfile(form);
      setMessage('اطلاعات با موفقیت ذخیره شد.');
      setTimeout(() => navigate('/profile'), 1500);
    } catch (err) {
      console.error('Error updating profile:', err);
      setMessage('خطا در ذخیره اطلاعات. لطفاً مجدد تلاش کنید.');
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return <div className="flex justify-center p-10"><Loader2 className="animate-spin text-purple-700" size={32} /></div>;
  }

  return (
    <div className="p-4 max-w-lg mx-auto rtl">
      <h1 className="text-2xl font-bold mb-6">ویرایش اطلاعات کاربری</h1>
      <form onSubmit={handleSubmit} className="space-y-4 bg-white rounded-xl shadow p-6">
        <div>
          <label className="block text-[11px] text-gray-600 mb-1">نام کامل</label>
          <input
            name="full_name"
            value={form.full_name}
            onChange={handleChange}
            className="w-full border border-gray-300 rounded-lg px-4 py-2"
            required
          />
        </div>
        <div>
          <label className="block text-[11px] text-gray-600 mb-1">ایمیل</label>
          <input
            name="email"
            type="email"
            value={form.email}
            onChange={handleChange}
            className="w-full border border-gray-300 rounded-lg px-4 py-2"
          />
        </div>
        <div>
          <label className="block text-[11px] text-gray-600 mb-1">شماره تماس</label>
          <input
            name="phone_number"
            value={form.phone_number}
            onChange={handleChange}
            className="w-full border border-gray-300 rounded-lg px-4 py-2"
            placeholder="09xxxxxxxxx"
          />
        </div>
        {message && <p className={`text-[11px] ${message.includes('موفق') ? 'text-green-600' : 'text-red-600'}`}>{message}</p>}
        <button
          type="submit"
          disabled={saving}
          className="w-full bg-purple-700 text-white py-2 rounded-lg font-medium hover:bg-purple-800 transition flex items-center justify-center gap-2"
        >
          {saving ? <Loader2 className="animate-spin" size={18} /> : <Save size={18} />}
          ذخیره تغییرات
        </button>
        <button
          type="button"
          onClick={() => goBack(navigate)}   // ✅ بازگشت هوشمند
          className="w-full text-gray-500 py-2 text-[11px] underline flex items-center justify-center gap-1"
        >
          <ArrowRight size={16} /> بازگشت
        </button>
      </form>
    </div>
  );
};